export default "__VITE_ASSET__D_bhU$un__"